import type { EmailAttachmentResponse } from '@vagusx/clients';

/** Status priority for deduplication — higher value wins. */
const STATUS_PRIORITY: Record<string, number> = {
  extracted: 4,
  failed: 3,
  processing: 2,
  skipped: 1,
  pending: 0,
};

/**
 * Deduplicate attachments by (emailId, attachmentIndex), keeping the one
 * with the best processing status. Multiple records per attachment can
 * exist from Inngest step retries.
 */
export function deduplicateAttachments(
  attachments: EmailAttachmentResponse[]
): EmailAttachmentResponse[] {
  const grouped = new Map<string, EmailAttachmentResponse>();
  for (const att of attachments) {
    const key = `${att.emailId}:${att.attachmentIndex}`;
    const existing = grouped.get(key);
    if (!existing || (STATUS_PRIORITY[att.status] ?? 0) > (STATUS_PRIORITY[existing.status] ?? 0)) {
      grouped.set(key, att);
    }
  }
  return Array.from(grouped.values());
}
